module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-czech.6e53c91b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-czech.png
// module id = 1118
// module chunks = 16